import Repository from "@/utils/API/Repository";
import {AxiosResponse} from "axios";
import {VideoCategory} from "@/models/TrainingVideo/VideoCategory";
import {TrainingVideo} from "@/models/TrainingVideo/TrainingVideo";

export const resource = '/trainingVideos';

export default {
  listCategories(): Promise<AxiosResponse<VideoCategory[]>> {
    return Repository.get(`${resource}/Categories`, { withCredentials: true });
  },
  createCategory(name: string): Promise<AxiosResponse<number>> {
    return Repository.post(
      `${resource}/Category`,
      { name },
      { withCredentials: true }
    );
  },
  updateCategory(id: number, name: string): Promise<AxiosResponse<void>> {
    return Repository.put(
      `${resource}/Category/${id}`,
      { name },
      { withCredentials: true }
    );
  },
  deleteCategory(id: number): Promise<AxiosResponse<void>> {
    return Repository.delete(`${resource}/Category/${id}`, { withCredentials: true });
  },
  updateCategoryOrder(categoryIds: number[]): Promise<AxiosResponse<void>> {
    return Repository.put(`${resource}/Category/Order`, categoryIds, { withCredentials: true });
  },
  listVideos(): Promise<AxiosResponse<TrainingVideo[]>> {
    return Repository.get(`${resource}/Videos`, { withCredentials: true });
  },
  getVideosByCategory(): Promise<AxiosResponse<{ CategoryId: number; Videos: TrainingVideo[] }[]>> {
    return Repository.get(`${resource}/Videos/ByCategory`, { withCredentials: true });
  },
  createVideo(video: TrainingVideo): Promise<AxiosResponse<number>> {
    return Repository.post(`${resource}/Video`, video, { withCredentials: true });
  },
  updateVideo(video: TrainingVideo): Promise<AxiosResponse<void>> {
    return Repository.put(`${resource}/Video`, video, { withCredentials: true });
  },
  deleteVideo(id: number): Promise<AxiosResponse<void>> {
    return Repository.delete(`${resource}/Video/${id}`, { withCredentials: true });
  },
  updateVideoOrder(videoIds: number[]): Promise<AxiosResponse<void>> {
    return Repository.put(`${resource}/Video/Order`, videoIds, { withCredentials: true });
  }
};